exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animated {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n  animation-delay: 800ms; }\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -50px, 0); }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); } }\n\n.fadeInDown {\n  animation-name: fadeInDown; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/dearmom/Sites/portfolio/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/dearmom/Sites/portfolio/node_modules/postcss-loader?{"ident":"postcss"}!/Users/dearmom/Sites/portfolio/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/dearmom/Sites/portfolio/src/assets/scss/animated.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/assets/scss/animated.scss
// module chunks = styles